import { type ReactNode } from "react";

interface SmallFeatureCardProps {
  className?: string;
  /** 32×32 icon */
  icon: ReactNode;
  /** Feature title */
  title: string;
  /** Feature description */
  description: string;
}

/** Compact feature card (416×140) for bottom row of «Возможности» */
export function SmallFeatureCard({ className = "", icon, title, description }: SmallFeatureCardProps) {
  return (
    <div
      className={`bg-white flex gap-[24px] max-desktop:gap-[16px] h-[152px] max-desktop:h-auto max-desktop:min-h-[152px] items-start max-desktop:items-center max-tablet:items-start justify-center p-[24px] rounded-[24px] w-[416px] max-w-full max-desktop:flex-col max-tablet:flex-row max-desktop:text-center max-tablet:text-left hover:shadow-[0px_0px_10px_rgba(0,0,0,0.07)] transition-shadow ${className}`}
    >
      <div className="size-[32px] shrink-0 overflow-hidden">
        {icon}
      </div>
      <div className="flex flex-1 flex-col gap-[8px] items-start max-desktop:items-center max-tablet:items-start min-w-0 w-full">
        <span
          className="[font-family:var(--font-commissioner)] font-medium not-italic text-[18px] leading-[24px] text-[rgba(0,0,0,0.9)] tracking-[-0.36px] whitespace-nowrap"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          {title}
        </span>
        <p
          className="[font-family:var(--font-commissioner)] font-medium not-italic text-[16px] leading-[20px] text-[rgba(0,0,0,0.4)]"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          {description}
        </p>
      </div>
    </div>
  );
}
